import * as React from 'react';

const OutdoorArea = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={22} viewBox="0 0 20 22" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
        >
            <path d="M18.75 10.375a4.37 4.37 0 0 0-2.542-3.958A2.462 2.462 0 0 0 13.75 3.5c-.053 0-.102.013-.154.016a4.364 4.364 0 0 0-7.192 0c-.052-.003-.101-.016-.154-.016a2.462 2.462 0 0 0-2.458 2.917 4.366 4.366 0 0 0 .921 8.237A3.402 3.402 0 0 0 10 15.818a3.402 3.402 0 0 0 5.287-1.166 4.37 4.37 0 0 0 3.463-4.277M10 7.875v12.5" />
            <path d="M10 13.5q3.75 0 3.75-3.75M10 11a2.953 2.953 0 0 1-3.125-3.125" />
        </g>
    </svg>
);
export default OutdoorArea;
